var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1619 0.269653C5.06921 0.269653 0.112305 5.22644 0.112305 11.3193C0.112305 17.4121 5.06921 22.3691 11.1619 22.3691C17.2547 22.3691 22.2116 17.4121 22.2116 11.3193C22.2116 5.22644 17.2548 0.269653 11.1619 0.269653ZM17.5068 9.45292L10.5649 16.3948C10.2697 16.69 9.87738 16.8525 9.45999 16.8525C9.0426 16.8525 8.65023 16.69 8.35506 16.3948L4.81705 12.8568C4.52188 12.5617 4.3593 12.1693 4.3593 11.7519C4.3593 11.3344 4.52188 10.942 4.81705 10.6469C5.1121 10.3517 5.50447 10.1891 5.92198 10.1891C6.33937 10.1891 6.73185 10.3517 7.02691 10.647L9.45987 13.0798L15.2968 7.24294C15.5919 6.94777 15.9843 6.78531 16.4017 6.78531C16.8191 6.78531 17.2114 6.94777 17.5066 7.24294C18.1161 7.85243 18.1161 8.84367 17.5068 9.45292Z",
    fill: "#46B764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptRequestIcon);
export default __webpack_public_path__ + "static/media/acceptRequestIcon.5e4785599748ef16c71accd2a3e06c85.svg";
export { ForwardRef as ReactComponent };